export const locale = {
  lang: 'en-CA',
  data: {
    ERROR_503: {
      CONTACT_US: 'Contact us',
      MESSAGE: 'We are undergoing scheduled maintenance.',
      // 'SUB_MESSAGE': 'Just kidding, looks like we have an internal issue, please try again in couple minutes',
      SUB_MESSAGE: "Sorry for the inconvenience, we'll be back shortly!",
      REPORT_PROBLEM: 'Report this problem',
      BACK_PAGE: 'Go back to the previous page',
      BACK_HOME_PAGE: 'Go back to dashboard',
      GT2_SITE: 'Go to www.gestiontraiteur.com',
      SUBJECT: 'Subject',
      SUCCESS_MESSAGE: 'Your message was sent successfully!',
      CONTACT_MESSAGE:
        'While we have been automatically informed, We always appreciate a more detailed feedback. Please contact us',
      RETRY: 'Retry',
      AUTO_CHECK: 'Automatic check every 30 seconds...',
      HUMOR_TIP: '☕ Perfect time for a coffee... or two!',
    },
  },
};
